module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAyMCAxMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI0ZGRiIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjxwYXRoIGQ9Ik0xLjUgMS41bDguNTE1IDguNTE1TTE4LjUgMS41bC04LjUxNSA4LjUxNSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollDown/arrow.svg
// module id = 414
// module chunks = 0